<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
    <path
      d="M6.75 19.313c-.063-.125-.125-.188-.188-.313C3.749 14.312 4.437 8.25 8.25 4.312l.063-.063.188-.188.063-.063c3.938-3.75 9.938-4.5 14.688-1.688.688.438.938 1.313.5 2.063-.438.688-1.313.938-2 .5-3.625-2.188-8.25-1.563-11.25 1.375-3 3-3.563 7.625-1.438 11.25.438.688.188 1.625-.5 2-.563.375-1.313.25-1.813-.188m4.062 4.003c-.438-.438-.563-1.188-.188-1.75.375-.688 1.313-.938 2-.5a9.271 9.271 0 0 0 11.25-1.438c2.938-3 3.563-7.625 1.375-11.25-.438-.688-.188-1.563.5-2s1.625-.188 2.063.5c2.813 4.75 2.063 10.75-1.688 14.688l-.063.063-.188.188c-.063 0-.063.063-.063.063-3.938 3.813-10 4.5-14.688 1.688-.125-.063-.188-.125-.313-.25M.438 29.688a1.471 1.471 0 0 1 0-2.063l5.438-5.438a1.37 1.37 0 0 1 2.063 0 1.37 1.37 0 0 1 0 2.063l-5.438 5.438c-.563.563-1.5.563-2.063 0"
    />
  </svg>
</template>

<script>
export default {
  name: 'SearchIcon',
};
</script>
